import { render } from "./AdminPermissionDefinition.vue?vue&type=template&id=14a306d0&scoped=true"
import script from "./AdminPermissionDefinition.vue?vue&type=script&lang=js"
export * from "./AdminPermissionDefinition.vue?vue&type=script&lang=js"

import "./AdminPermissionDefinition.vue?vue&type=style&index=0&id=14a306d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14a306d0"]])

export default __exports__